module.exports = __webpack_public_path__ + "static/media/LanternCityTheatreESTA0004_design_clean_v001.495439ca.png";